<div *ngIf="appGoneError===false" class="scg-errorcontainer">
  <div class="container">
    <div class="row scg-errorbox">
      <div class="scg-errortext">
        <div>
          <ng-container *ngIf="(errorData.deviceName != null && errorData.deviceName !== '') || (errorData.username != null && errorData.username !== '')">{{errorData.deviceName}} {{errorData.username}}</ng-container>
          <ng-container *ngIf="errorData.errorCode != null"><br>Error Code: {{errorData.errorCode}}</ng-container>
          <ng-container *ngIf="errorData.url != null && errorData.url !== ''"><br>{{errorData.url}}</ng-container>
          <ng-container *ngIf="errorData.httpCode != null"><br>API Call failed Code ({{errorData.httpCode}})</ng-container>
          <ng-container *ngIf="errorData.msg != null && errorData.msg !== ''"><br>{{errorData.msg}}</ng-container>
        </div>
        <div class="d-flex justify-content-end mt-2">
          <!-- btn-sm is okay here -->
          <button type="button" (click)="copyErrMsg()" class="btn btn-sm btn-outline-secondary">{{'ERROR.COPY_MSG'|translate}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="container" style="margin-top:15px">
    <div class="row">
      <div *ngIf="errorData.errorCode!=5001">
        <b>{{'ERROR.MSG_1'|translate}}</b> {{'ERROR.MSG_2'|translate}}
      </div>
      <div *ngIf="errorData.errorCode===5001">
        <b>{{'ERROR.5001_1'|translate}}</b> {{'ERROR.5001_2'|translate}}
      </div>
      </div>
  </div>
</div>


<div *ngIf="appGoneError===true" class="scg-errorcontainer">
  <div class="container">
   <span *ngIf="appSystemError===false && appAudioError==false">{{'ERROR.APP_NOT_FOUND'|translate}}</span>
    <span *ngIf="appSystemError===true">{{'ERROR.APP_SYSTEM'|translate}}</span>
    <span *ngIf="appAudioError===true">{{'ERROR.APP_AUDIO'|translate}}<br><br>{{'ERROR.APP_AUDIO_LIMIT'|translate}}</span>
  </div>
</div>

